<template>
  <div class="">
    <el-form
      ref="form"
      :model="form"
      label-width="110px"
    >
      <el-form-item label="手机类型">
        <el-select
          v-model="form.login_type"
          placeholder="请选择"
          @change="phonetype"
        >
          <el-option
            v-for="item in optionsphone"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="
          form.login_type == 2 || form.login_type == 3 || form.login_type == 4
        "
        label="云手机实例"
      >
        <el-tag
          v-if="form.instance_id != ''"
          style="margin-right: 10px"
        >{{
          pod_name
        }}</el-tag>
        <el-button
          type="primary"
          size="mini"
          @click="chooseshili"
        >选择实例</el-button>
      </el-form-item>
      <el-form-item label="Android ID">
        <el-input v-model="form.equipment_code" />
      </el-form-item>

      <el-form-item label="设备名称">
        <el-input v-model="form.phone_name" />
      </el-form-item>
      <el-form-item label="企微版本">
        <!-- <el-input v-model="form.ww_version" /> -->
        <el-select
          v-model="form.ww_version"
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        v-if="form.status"
        label="状态"
      >
        <el-select
          v-model="form.status"
          placeholder="请选择"
        >
          <el-option
            v-for="item in [
              { id: 1, value: '正常' },
              { id: 2, value: '停用' }
            ]"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button
          type="primary"
          :disabled="creatrdiar"
          @click="onSubmit"
        >立即创建</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择云手机实例"
      :visible.sync="yunphonewdialogr"
      :destroy-on-close="true"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="60%"
    >
      <yunphonedialog
        ref="yunphonedialogview"
        @callback="callback"
      />
    </el-dialog>
  </div>
</template>

<script>
import yunphonedialog from './yunphonedialog.vue'
import { phonelist } from '@/api/enterprisewechatControl'
export default {
  components: {
    yunphonedialog
  },
  props: {
    currentItem: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      form: {
        login_type: this.currentItem.login_type,
        // eslint-disable-next-line eqeqeq
        instance_id: this.currentItem.instance_id == undefined ? '' : this.currentItem.instance_id,
        ww_version: this.currentItem.ww_version,
        equipment_code: this.currentItem.equipment_code, // 安卓id
        phone_name: this.currentItem.phone_name, // 设备名称
        status: Object.keys(this.currentItem).length ? this.currentItem.status : undefined // 状态
      },
      pod_name: '',
      yunphonewdialogr: false,
      options: [
        {
          value: '4.1.28',
          label: '4.1.28'
        },
        {
          value: '4.1.30',
          label: '4.1.30'
        },
        {
          value: '4.1.31',
          label: '4.1.31'
        },
        {
          value: '4.1.32',
          label: '4.1.32'
        }
      ],
      optionsphone: [],
      creatrdiar: false
    }
  },
  created() {},
  methods: {
    async onSubmit() {
      // this.judge() && this.$emit('determine', this.form)
      if (this.judge()) {
        this.creatrdiar = true // 禁用按钮，防止重复点击
        try {
        // 假设这里是你的创建逻辑
          await this.$emit('determine', this.form)

        // 如果创建成功，这里不需要立刻恢复按钮
        // 如果需要继续用同一个页面创建，可以手动置为 false
        } catch (err) {
        // 失败恢复按钮
          this.creatrdiar = false
        }
      }
    },
    send(type) {
      this.phonelistall()
      // eslint-disable-next-line eqeqeq, no-empty
      if (type == 1) {
      } else {
        // eslint-disable-next-line eqeqeq
        if (this.form.login_type == 2) {
          console.log('火山')
          this.pod_name = this.currentItem.instance_name
        // eslint-disable-next-line eqeqeq
        } else if (this.form.login_type == 3) {
          console.log('腾讯云')
          this.pod_name = this.currentItem.instance_name
        } else {
          console.log('阿里云')
          this.pod_name = this.currentItem.instance_name
        }
      }
    },
    phonelistall() {
      phonelist().then(res => {
        console.log(res)
        this.optionsphone = res.data
      })
    },
    judge() {
      let text = null
      if (!this.form.equipment_code) {
        text = '请输入Android ID'
      } else if (!this.form.phone_name) {
        text = '请输入设备名称'
      } else if (!this.form.ww_version) {
        text = '请输入企微版本'
      } else if (!this.form.login_type) {
        text = '请选择手机类型'
      }

      text &&
        this.$message({
          message: text,
          type: 'warning'
        })

      return !text
    },
    chooseshili() {
      this.yunphonewdialogr = true
      this.$nextTick(() => {
        this.$refs.yunphonedialogview.send(this.form.login_type)
      })
    },
    callback(pod_name, instance_id) {
      this.yunphonewdialogr = false
      this.pod_name = pod_name
      this.form.instance_id = instance_id
    },
    phonetype(val) {
      console.log('val', val, this.currentItem.instance_id)
      this.pod_name = ''
      this.form.instance_id = ''
      // if (val == 1) {
      //   ;(this.pod_name = ''), (this.form.instance_id = '')
      // } else if (val == 2) {
      //   ;(this.pod_name = ''), (this.form.instance_id = '')
      // }
    }
  }
}
</script>

<style scoped>
.erBox {
  width: 100px;
  height: 100px;
  border: 1px solid #ccc;
  cursor: pointer;
  position: relative;
}

.erBox::before {
  content: '';
  position: absolute;
  width: 1px;
  height: 50px;
  background-color: #ccc;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.erBox::after {
  content: '';
  position: absolute;
  width: 50px;
  height: 1px;
  background-color: #ccc;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.erBox:hover {
  border-color: rgb(7, 123, 201);
}

.erBox:hover::after,
.erBox:hover::before {
  background-color: rgb(7, 123, 201);
}

.file {
  display: none;
}

.imgBox {
  width: 100px;
  height: 100px;
  position: relative;
}

.imgBox:hover span {
  display: inline-block !important;
}

.imgBox span {
  width: 100%;
  height: 100%;
  background-color: rgba(200, 200, 200, 0.5);
  position: absolute;
  z-index: 11;
  left: 0px;
  display: none;
}

.myi {
  cursor: pointer;
  font-size: 25px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
